import { Paper, Typography } from '@mui/material'
import { FC, ReactNode, Ref } from 'react'
import styles from './MitenePaper.module.scss'

export interface Props {
  readonly title?: ReactNode
  readonly body?: ReactNode
  readonly tabIndex?: number
  forwardRef?: Ref<HTMLDivElement>
}

interface Style {
  readonly className?: string
  readonly variant: 'h6' | 'body1'
}

export const MitenePaper: FC<Props> = (prop: Props) => {
  const { title, body, tabIndex, forwardRef } = prop

  return (
    <Paper elevation={2} className={styles.paper} tabIndex={tabIndex} ref={forwardRef} >
      {title && message(title, { className: styles.title, variant: 'h6' })}
      {body && message(body, { variant: 'body1' })}
    </Paper>
  )
}

const message = (content: ReactNode, style: Style) => {
  return (
    <Typography color='textPrimary' className={style.className} variant={style.variant} sx={{ display: 'block' }}>
      {content}
    </Typography>
  )
}
